import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment'
import {GranServicioDePTWService}from '../gran-servicio-de-ptw.service'
import * as firebase from 'firebase'
import { AlertController, ToastController,LoadingController } from '@ionic/angular';
import { callbackify } from 'util';
import { MisPermisosPage } from '../mis-permisos/mis-permisos.page';


@Component({
  selector: 'app-modal-crear-trabajador',
  templateUrl: './modal-crear-trabajador.page.html',
  styleUrls: ['./modal-crear-trabajador.page.scss'],
})
export class ModalCrearTrabajadorPage implements OnInit {
  
  @Input()cedula;
  @Input()tipoId;
  actividadSeleccionada;

  subiendo=''
  
  nombre=''
  // tipoID=''
  // cedula=''
  telefono=''
  arl=''
  fechaAfiliacionARL=''
  urlParafiscales=''

  docId=''
  arraydeSoportes=[]
  arrayDocumentosPorActividad=[]; 

  urlCertificadoAlturas=''
  urlCertificadoAptitud=''
  urlCertificadoIzaje=''
  urlCertificadoCONTE=''
  urlCertificadoConfinados=''
  urlCertificadoAptitudConfinados=''
  urlCertificadoEquiposConfinados=''

  


  //--variables de subir parafiscales
  changedData=true
  percentage=0;

  constructor(public granServicioDePTWService:GranServicioDePTWService, public modalCtrl: ModalController, public alertController: AlertController, public toast: ToastController, public loadingController: LoadingController) { }

  ngOnInit() {
  }

  ionViewWillEnter(){
  
  }

 

  



  formateafechaparadisplay(){
    this.fechaAfiliacionARL = moment(this.fechaAfiliacionARL).format('YYYY-MM-DD');
  }


  inputfile(event,nombreparametro) {
    this.presentLoading("Cargando archivo...");

    this.subiendo = nombreparametro
    this.changedData=true
    this.percentage=0;
    // File or Blob named mountains.jpg
    var file = event.target.files[0]

    // Create the file metadata
    var metadata = {
      // contentType: 'image/jpeg'
    };
    // Upload file and metadata to the object 'images/mountains.jpg'
    let storageRef = firebase.storage().ref('parafiscales/' + Date.now())
    var uploadTask = storageRef.child('images/' + file.name).put(file, metadata);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded

        this.percentage = (snapshot.bytesTransferred / snapshot.totalBytes)
        console.log('Upload is ' + this.percentage + '% done');
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      }, (error) => {
        console.log(error);
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        this.loadingController.dismiss()
        this.alerta("Error",error)
      }, () => {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          console.log('File available at', downloadURL);

          if(nombreparametro == 'parafiscales'){
            this.urlParafiscales=downloadURL
            this.loadingController.dismiss()
          }
            if(nombreparametro == 'Cert. trabajo en alturas'){
            this.urlCertificadoAlturas=downloadURL
            this.arraydeSoportes.push({actividad:"TRABAJO EN ALTURAS",documento:nombreparametro,url:downloadURL})
            this.loadingController.dismiss()
            console.log("ARRAY DE SOPORTES: "+this.arraydeSoportes)
          }
          if(nombreparametro == 'Cert. aptitud ocupacional'){
            this.urlCertificadoAptitud=downloadURL
            this.arraydeSoportes.push({actividad:"TRABAJO EN ALTURAS",documento:nombreparametro,url:downloadURL})
            this.loadingController.dismiss()
            console.log("ARRAY DE SOPORTES: "+this.arraydeSoportes)
          }
          if(nombreparametro == 'Cert. para izaje'){
            this.urlCertificadoIzaje=downloadURL
            this.arraydeSoportes.push({actividad:"LEVANTAMIENTO MECÁNICO",documento:nombreparametro,url:downloadURL})
            this.loadingController.dismiss()
            console.log("ARRAY DE SOPORTES: "+this.arraydeSoportes)
          }
          if(nombreparametro == 'Cert. conte'){
            this.urlCertificadoCONTE=downloadURL
            this.arraydeSoportes.push({actividad:"ENERGÍAS PELIGROSAS",documento:nombreparametro,url:downloadURL})
            this.loadingController.dismiss()
            console.log("ARRAY DE SOPORTES: "+this.arraydeSoportes)
          }
          if(nombreparametro == 'Cert. confinados'){
            this.urlCertificadoConfinados=downloadURL
            this.arraydeSoportes.push({actividad:"ESPACIOS CONFINADOS",documento:nombreparametro,url:downloadURL})
            this.loadingController.dismiss()
            console.log("ARRAY DE SOPORTES: "+this.arraydeSoportes)
          }
          if(nombreparametro == 'Cert. aptitud confinados'){
            this.urlCertificadoAptitudConfinados=downloadURL
            this.arraydeSoportes.push({actividad:"ESPACIOS CONFINADOS",documento:nombreparametro,url:downloadURL})
            this.loadingController.dismiss()
            console.log("ARRAY DE SOPORTES: "+this.arraydeSoportes)
          }
          if(nombreparametro == 'Cert. equipos confinados'){
            this.urlCertificadoEquiposConfinados=downloadURL
            this.arraydeSoportes.push({actividad:"ESPACIOS CONFINADOS",documento:nombreparametro,url:downloadURL})
            this.loadingController.dismiss()
          }

          this.loadingController.dismiss()

        }).catch((err)=>{
          this.loadingController.dismiss()
        this.alerta("Error",err)
        });
        
      });
  }



  deleteDocument(url,nombredeldocumento){

    let objetodeUpdate={}

    // Create a reference to the file to delete
    var httpsReference = firebase.storage().refFromURL(url)
    // Delete the file
    httpsReference.delete().then(()=> {

    // File deleted successfully
      this.percentage=0 
          if(nombredeldocumento == 'parafiscales'){
            this.urlParafiscales='' ;
            objetodeUpdate = {urlParafiscales:''}
          }else
          if(nombredeldocumento == 'certificadoAlturas'){
            this.urlCertificadoAlturas='' ;
            objetodeUpdate = {urlCertificadoAlturas:''}
          }else
          if(nombredeldocumento == 'CertificadoAptitud'){
            this.urlCertificadoAptitud='' ;
            objetodeUpdate = {urlCertificadoAptitud:''}
          }else
          if(nombredeldocumento == 'certificadoIzaje'){
            this.urlCertificadoIzaje='' ;
            objetodeUpdate = {urlCertificadoIzaje:''}
          }else
          if(nombredeldocumento == 'certificadoCONTE'){
            this.urlCertificadoCONTE='' ;
            objetodeUpdate = {urlCertificadoCONTE:''}
          }else
          if(nombredeldocumento == 'certificadoConfinados'){
            this.urlCertificadoConfinados='' ;
            objetodeUpdate = {urlCertificadoConfinados:''}
          }else
          if(nombredeldocumento == 'CertificadoAptitudConfinados'){
            this.urlCertificadoAptitudConfinados='' ;
            objetodeUpdate = {urlCertificadoAptitudConfinados:''}
          }else
          if(nombredeldocumento == 'CertificadoEquiposConfinados'){
            this.urlCertificadoEquiposConfinados='' ;
            objetodeUpdate = {urlCertificadoEquiposConfinados:''}
          }
          
      })
      .then(()=>{
        //falta poner update para que se actualice la url antes de guardar.
         firebase.firestore().collection("trabajadores").doc(this.tipoId+this.cedula).update(objetodeUpdate)
      })
      
      
      .catch((error)=> {
        // Uh-oh, an error occurred!
        this.alerta("¡Error!",error)
      });
    }



 

    //aca falta incluir cancelar todos los demas documentos que no sean parafiscales
  cancelar(){
    
    if(this.urlParafiscales == ''){
      this.modalCtrl.dismiss();
    }else
    if(this.urlParafiscales!=''){
      this.presentLoading("Eliminando archivos...")
      // Create a reference to the file to delete
      var httpsReference = firebase.storage().refFromURL(this.urlParafiscales)
      // Delete the file
      httpsReference.delete().then(()=> {
 
     // File deleted successfully
       console.log("Deleted OK")
       console.log()

         this.percentage=0 
         
       this.loadingController.dismiss()
       this.urlParafiscales='' 
       this.modalCtrl.dismiss(); 
       }).catch((error)=> {
        this.loadingController.dismiss()
         this.alerta("¡Error!",error)
         this.modalCtrl.dismiss();
       });
    }
    

  }



  crearEmpleado(){
    this.presentLoading("Creando trabajador...")
    let docIdParaQuery = this.tipoId+this.cedula
    firebase.firestore().collection("trabajadores").doc(docIdParaQuery).set({
      nombre:this.nombre,
      tipoID:this.tipoId,
      cedula:this.cedula,
      telefono:this.telefono,
      arl:this.arl,
      fechaAfiliacionARL:moment(this.fechaAfiliacionARL).format('YYYY-MM-DD'),
      urlParafiscales:this.urlParafiscales,
      // arraydeSoportes:this.arraydeSoportes,

      urlCertificadoAlturas:this.urlCertificadoAlturas,
      urlCertificadoAptitud:this.urlCertificadoAptitud,
      urlCertificadoIzaje:this.urlCertificadoIzaje,
      urlCertificadoCONTE:this.urlCertificadoCONTE,
      urlCertificadoConfinados:this.urlCertificadoConfinados,
      urlCertificadoAptitudConfinados:this.urlCertificadoAptitudConfinados,
      urlCertificadoEquiposConfinados:this.urlCertificadoEquiposConfinados

    }).then((doc)=>{

        

      //despues de creado el trabajador, lo metemos en el documento de solicitud

        firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
          
          // con firebase.firestore.FieldValue.arrayUnion añadimos un item al array de empleados
          arrayDeEmpleados: firebase.firestore.FieldValue.arrayUnion({
            id:docIdParaQuery,
            arraydeactividades:[],
            // datosTrabajador:{
            //   nombre:this.nombre,
            //   tipoID:this.tipoId,
            //   cedula:this.cedula,
            //   telefono:this.telefono,
            //   arl:this.arl,
            //   fechaAfiliacionARL:moment(this.fechaAfiliacionARL).format('YYYY-MM-DD'),
            //   urlParafiscales:this.urlParafiscales,
            // }
          })
        }).then(()=>{
          this.loadingController.dismiss()
          this.modalCtrl.dismiss();
        }).catch((err)=>{
          this.loadingController.dismiss()
          this.alerta("Error", err)
        })

        // this.loadingController.dismiss()
        // this.modalCtrl.dismiss();

    }).catch((err)=>{
      this.modalCtrl.dismiss();
      this.alerta("Error",err)
    })
  }




  async presentLoading(mensaje) {
    const loading = await this.loadingController.create({
      message: mensaje,
    });
    await loading.present();
    const { role, data } = await loading.onDidDismiss();
    console.log('Loading dismissed!');
  }

  async alerta(entradaheader, entradamessage) {
    const alert = await this.alertController.create({
      header: entradaheader,
      message: entradamessage,
      buttons: [
        {
          text: 'OK',
          handler: () => {
         }
        }
      ]
    });
    await alert.present();
  }



}//fin de clase
